import Vue from 'vue';
import { IApplication, createApplication } from './app';
// import './registerServiceWorker';

Vue.config.productionTip = false;

const { app, router }: IApplication = createApplication();

router.onReady(() => {
  app.$mount('#app');
});
